const translations = {
  en: {
    brand: '🍵 match-a',
    matches: 'Matches',
    profile: 'Profile',
    signOut: 'Sign out',
    welcomeBack: 'Welcome back',
    createAccount: 'Create your account',
    startConnecting: 'Start connecting over lunch.',
    signInToSee: 'Sign in to see your matches.',
    fullName: 'FULL NAME',
    email: 'EMAIL',
    password: 'PASSWORD',
    pleaseEnterEmail: 'Please enter your email address',
    createAccountBtn: 'Create Account',
    signInBtn: 'Sign In',
    sendMagicLink: 'Send Magic Link',
    useMagicLink: 'Use magic link instead',
    usePasswordInstead: 'Use password instead',
    or: 'or',
    continueWithGoogle: 'Continue with Google',
    continueWithMicrosoft: 'Continue with Microsoft',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    signIn: 'Sign in',
    signUpFree: 'Sign up free',
    requestAccess: 'Request access',
    requestAccessTitle: 'Request access',
    requestAccessSubtitle: 'Fill in the form below and we\'ll get back to you soon.',
    requestAccessName: 'FULL NAME',
    requestAccessCompany: 'COMPANY',
    requestAccessRelation: 'RELATION WITH SCCIJ',
    requestAccessRelationPlaceholder: 'e.g. Member, Guest, Partner…',
    requestAccessBtn: 'Send request',
    faqNav: 'FAQ',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Everything you need to know about <em>match-a</em>.',
    heroTitle: 'Meet someone new over lunch.',
    heroSubtitle: '<em>Match-a</em> matches you with colleagues across industries based on shared languages and availability — once per lunch, never twice.',
    findFirstMatch: 'Find my first match →',
    howItWorks: 'How it works',
    readyForNext: 'Ready for your next great lunch?',
    joinToday: 'Join <em>Match-a</em> today — it\'s free.',
    createYourAccount: '🍵 Create your account',
    step1Title: 'Set your industry',
    step1Desc: 'Tell us which industry you\'re in and which others you\'d like to meet.',
    step2Title: 'Add languages',
    step2Desc: 'Share which languages you speak so we can connect you meaningfully.',
    step3Title: 'Mark free days',
    step3Desc: 'Pick your available lunch days on the calendar each month.',
    step4Title: 'Get matched',
    step4Desc: 'We find your ideal match and notify you by email. Chat, meet, enjoy!',
    noMatchesYet: 'You have no current matches',
    matchesIntro: 'Here are your lunch matches.',
    loadingMatches: 'Loading your matches...',
    noMatchesInfo: 'Matching runs every Monday at noon. To improve your chances of being matched, try keeping your availability, languages, locations, and group size preferences as open as possible.',
    upcomingLunches: 'Upcoming Lunches',
    pastLunches: 'Past Lunches',
    chat: 'Chat',
    addToCalendar: 'Add to calendar',
    confirmEmail: 'Confirm your email address',
    verifyEmailBtn: 'Verify my email',
    verifyingEmail: 'Verifying your email...',
    verifyWait: 'Please wait while we verify your email address.',
    verifiedOK: 'Email verified successfully',
    alreadyVerified: 'Email already verified',
    invalidToken: 'Invalid or expired verification token',
    magicLinkVerifying: 'Please wait while we verify your magic link.',
    noAccount: 'No account found with this email',
    verifyEmailFirst: 'Please verify your email before using magic link',
    redirectLogin: 'Redirecting to login page...',
    verificationFailed: 'Verification failed',
    goToLogin: 'Go to Login',
    completingSignIn: 'Completing sign in...',
    setupAccount: 'Please wait while we set up your account.',
    profileTabBusiness: 'Industry',
    profileTabLocation: 'Location',
    profileTabLanguages: 'Languages',
    profileTabAvailability: 'Availability',
    profileMyUnits: 'Industry I\'m in',
    profileInterestedUnits: 'Industries I\'m interested in',
    profileSelectApplies: 'Select all that apply — multiple selection possible.',
    profileMatchLocation: 'You\'ll only be matched with people who share at least one interest with you.',
    profileLanguagesSpeak: 'Languages You Speak',
    profileAvailability: 'Lunch Availability',
    profileAvailabilityInfo: 'Select days you\'re free for lunch. You can update this anytime.',
    calendarLockNote: 'Availability can be updated until Monday noon JST, after which next week is locked for matching.',
    anyLabel: 'Any',
    profileSaveChanges: 'Save Changes',
    profileSaved: '✓ Saved!',
    onboardingHeader: 'Set up your profile',
    onboardingSubheader: 'This helps us find your best lunch matches',
    onboardingStepBusiness: 'Industry',
    onboardingStepLocation: 'Location',
    onboardingStepLanguages: 'Languages',
    onboardingStepAvailability: 'Availability',
    onboardingQuestionBusiness: 'Which industry are you in?',
    onboardingQuestionInterested: 'Which industries are you interested in?',
    onboardingQuestionLocation: 'Which office locations are you based at?',
    onboardingQuestionLanguages: 'Which languages do you speak?',
    onboardingQuestionAvailability: 'When are you available for lunch?',
    onboardingQuestionAvailabilityDesc: "Tap the days you're available. We'll only match you on days both of you are free.",
    onboardingBack: '← Back',
    onboardingNext: 'Next →',
    onboardingFinish: '🍵 Find my matches!',
    onboardingSaving: 'Saving...',
    onboardingSkip: 'Skip',
    onboardingFinishLabel: 'Finish',
    onboardingStepGroupSize: 'Group Size',
    onboardingQuestionGroupSize: 'How would you like to lunch?',
    groupSize2Label: '1:1 — Just the two of us',
    groupSize2Desc: 'A focused one-on-one conversation',
    groupSize3Label: '3 people — Small group',
    groupSize3Desc: 'A lively small group lunch',
    groupSize4Label: '4 people — Bigger table',
    groupSize4Desc: 'Meet more people at once',
    profileTabPreferences: 'Group size',
    profileGroupSizeTitle: 'Lunch group size',
    profileTabPassword: 'Password',
    profileChangePassword: 'Change Password',
    profileCurrentPassword: 'CURRENT PASSWORD',
    profileNewPassword: 'NEW PASSWORD',
    profileConfirmPassword: 'CONFIRM NEW PASSWORD',
    profileUpdatePassword: 'Update Password',
    profilePasswordUpdated: '✓ Password updated!',
    profilePasswordMismatch: 'New passwords do not match',
    profilePasswordTooShort: 'Password must be at least 8 characters',
    profileOAuthPassword: 'Your account uses {provider} sign-in. Password changes are not available.',
    profileDangerZoneTitle: 'Danger Zone',
    profileDeleteAccountDesc: 'Permanently delete your account and all your profile data. This cannot be undone.',
    profileDeleteAccountBtn: 'Delete My Account',
    profileDeleteConfirmDesc: 'Are you sure? This will permanently delete your account and cannot be undone.',
    profileDeleteConfirmPasswordLabel: 'CONFIRM YOUR PASSWORD',
    profileDeleteConfirmBtn: 'Yes, Delete My Account',
    profileDeleteCancelBtn: 'Cancel',
    resetPasswordLink: 'Reset password via email',
    sendResetLink: 'Send Reset Link',
    resetPasswordTitle: 'Reset your password',
    resetPasswordSubtitle: 'Enter a new password for your account.',
    resetPasswordBtn: 'Set New Password',
    resetInvalidToken: 'Invalid or missing reset token. Please request a new password reset.',
    resetRedirectingLogin: 'Redirecting to login page...',
    authTagline: 'Lunch, but make it meaningful.',
    authTaglineSubtitle: '<em>match-a</em> connects you with someone new every week — matched by your interests, your languages, and when you\'re free.',
    requestHeroSubtitle: '<em>match-a</em> connects SCCIJ members with each other over lunch — matched by interests, languages, and availability.',
    authStep1: 'Share your interests & languages',
    authStep2: 'Pick your free lunch days',
    authStep3: 'We find your perfect match',
    authStep4: 'Enjoy a new connection!'
  },
  ja: {
    brand: '🍵 match-a',
    matches: 'マッチ',
    profileTabBusiness: '業界',
    profileTabLocation: 'エリア',
    profileTabLanguages: '言語',
    profileTabAvailability: '空き時間',
    profileMyUnits: '自分が属する業界',
    profileInterestedUnits: '興味のある業界',
    profileSelectApplies: '該当するものをすべて選択してください (複数選択可)。',
    profileMatchLocation: '共通の興味を持つメンバーとマッチします(複数選択可)。',
    profileLanguagesSpeak: '話せる言語',
    profileAvailability: 'ランチ可能日',
    profileAvailabilityInfo: 'ランチが可能な日を選択してください。いつでも更新できます。',
    calendarLockNote: '日程変更は月曜の正午までです。それ以降は翌週のマッチングが確定しているため、変更できなくなります。',
    anyLabel: '全て',
    profileSaveChanges: '変更を保存',
    profileSaved: '✓ 保存されました！',
    onboardingHeader: 'プロフィールを設定',
    onboardingSubheader: '最適なランチマッチを見つけるために準備しましょう',
    onboardingStepBusiness: '業界',
    onboardingStepLocation: 'エリア',
    onboardingStepLanguages: '言語',
    onboardingStepAvailability: '空き時間',
    onboardingQuestionBusiness: 'あなたの業界はどこですか？',
    onboardingQuestionInterested: '興味のある業界はどこですか？',
    onboardingQuestionLocation: 'どのオフィス拠点にいますか？',
    onboardingQuestionLanguages: 'どの言語を話しますか？',
    onboardingQuestionAvailability: 'ランチ可能な日を選択してください',
    onboardingQuestionAvailabilityDesc: '利用可能な日をタップしてください。両方が空いている日にのみマッチングします。',
    onboardingBack: '← 戻る',
    onboardingNext: '次へ →',
    onboardingFinish: '🍵 マッチを探す！',
    onboardingSaving: '保存中...',
    onboardingSkip: 'スキップ',
    onboardingFinishLabel: '完了',
    onboardingStepGroupSize: 'グループサイズ',
    onboardingQuestionGroupSize: 'ランチのスタイルを選んでください',
    groupSize2Label: '1対1',
    groupSize2Desc: '一対一のランチ',
    groupSize3Label: '3人グループ',
    groupSize3Desc: '少人数グループランチ',
    groupSize4Label: '4人グループ',
    groupSize4Desc: 'より多くの人と出会う',
    profileTabPreferences: 'グループサイズ',
    profileGroupSizeTitle: 'ランチグループサイズ',
    profile: 'プロフィール',
    signOut: 'ログアウト',
    welcomeBack: 'おかえりなさい',
    createAccount: 'アカウントを作成',
    startConnecting: 'ランチでつながりを始めましょう。',
    signInToSee: 'マッチを見るにはログインしてください。',
    fullName: '名前',
    email: 'メールアドレス',
    password: 'パスワード',
    pleaseEnterEmail: 'メールアドレスを入力してください',
    createAccountBtn: 'アカウントを作成',
    signInBtn: 'ログイン',
    sendMagicLink: 'マジックリンクを送信',
    useMagicLink: 'マジックリンクを使う',
    usePasswordInstead: 'パスワードを使う',
    or: 'または',
    continueWithGoogle: 'Googleで続行',
    continueWithMicrosoft: 'Microsoftで続行',
    alreadyHaveAccount: '既にアカウントをお持ちですか？',
    dontHaveAccount: 'アカウントをお持ちでない場合',
    signIn: 'ログイン',
    signUpFree: '無料登録',
    requestAccess: 'アクセスを申請',
    requestAccessTitle: 'アクセス申請',
    requestAccessSubtitle: '下記フォームにご記入ください。折り返しご連絡いたします。',
    requestAccessName: '氏名',
    requestAccessCompany: '会社名',
    requestAccessRelation: 'SCCIJとの関係',
    requestAccessRelationPlaceholder: '例：会員、ゲスト、パートナー…',
    requestAccessBtn: '申請を送信',
    faqNav: 'FAQ',
    faqTitle: 'よくある質問',
    faqSubtitle: '<em>match-a</em>に関するよくあるご質問をまとめました。',
    heroTitle: 'ランチで誰かと出会いましょう。',
    heroSubtitle: '<em>Match-a</em>は、共通の言語と空き時間に基づいて同僚とマッチングします。',
    findFirstMatch: '最初のマッチを探す →',
    howItWorks: '使い方',
    readyForNext: '次のランチの準備はできていますか？',
    joinToday: '今すぐ<em>Match-a</em>に参加しましょう。無料です。',
    createYourAccount: '🍵 アカウントを作成',
    step1Title: '所属部署を設定',
    step1Desc: 'あなたのチームと会いたいチームを教えてください。',
    step2Title: '言語を追加',
    step2Desc: '話せる言語を共有すると、意味のあるつながりができます。',
    step3Title: '空き日を設定',
    step3Desc: '毎月のランチ可能日をカレンダーで選択します。',
    step4Title: 'マッチング',
    step4Desc: '理想のマッチを見つけてメールでお知らせします。チャットして会いましょう！',
    noMatchesYet: '現在マッチはありません',
    matchesIntro: 'あなたのランチマッチを表示します。',
    loadingMatches: 'マッチを読み込み中...',
    noMatchesInfo: 'マッチングは毎週月曜日の正午に実行されます。マッチの可能性を高めるには、空き日・言語・場所・希望グループサイズをできるだけ幅広く設定してください。',
    upcomingLunches: '今後のランチ',
    pastLunches: '過去のランチ',
    chat: 'チャット',
    addToCalendar: 'カレンダーに追加',
    confirmEmail: 'メールアドレスを確認する',
    verifyEmailBtn: 'メールを確認する',
    verifyingEmail: 'メールを確認中...',
    verifyWait: 'メールアドレスを確認しています。しばらくお待ちください。',
    verifiedOK: 'メールが正常に確認されました',
    alreadyVerified: 'メールはすでに確認されています',
    invalidToken: '無効または期限切れのトークンです',
    magicLinkVerifying: 'マジックリンクを確認しています。しばらくお待ちください。',
    noAccount: 'このメールアドレスのアカウントが見つかりません',
    verifyEmailFirst: 'マジックリンクを使う前にメールを確認してください',
    redirectLogin: 'ログインページにリダイレクトしています...',
    verificationFailed: '確認に失敗しました',
    goToLogin: 'ログインへ進む',
    completingSignIn: 'ログインを完了しています...',
    setupAccount: 'アカウントを設定しています。しばらくお待ちください。',
    profileTabPassword: 'パスワード',
    profileChangePassword: 'パスワード変更',
    profileCurrentPassword: '現在のパスワード',
    profileNewPassword: '新しいパスワード',
    profileConfirmPassword: '新しいパスワード（確認）',
    profileUpdatePassword: 'パスワードを更新',
    profilePasswordUpdated: '✓ パスワードを更新しました！',
    profilePasswordMismatch: '新しいパスワードが一致しません',
    profilePasswordTooShort: 'パスワードは8文字以上にしてください',
    profileOAuthPassword: 'アカウントは{provider}でログインしています。パスワードの変更はできません。',
    profileDangerZoneTitle: '危険な操作',
    profileDeleteAccountDesc: 'アカウントとすべてのプロフィールデータを完全に削除します。この操作は取り消せません。',
    profileDeleteAccountBtn: 'アカウントを削除',
    profileDeleteConfirmDesc: '本当によろしいですか？アカウントは完全に削除され、元に戻すことはできません。',
    profileDeleteConfirmPasswordLabel: 'パスワードを入力して確認',
    profileDeleteConfirmBtn: 'はい、アカウントを削除します',
    profileDeleteCancelBtn: 'キャンセル',
    resetPasswordLink: 'メールでパスワードをリセット',
    sendResetLink: 'リセットリンクを送信',
    resetPasswordTitle: 'パスワードのリセット',
    resetPasswordSubtitle: '新しいパスワードを入力してください。',
    resetPasswordBtn: '新しいパスワードを設定',
    resetInvalidToken: '無効またはリセットトークンがありません。再度パスワードリセットをリクエストしてください。',
    resetRedirectingLogin: 'ログインページにリダイレクトしています...',
    authTagline: 'ランチから始まる、新しいビジネス交流',
    authTaglineSubtitle: 'match-aは興味・言語・スケジュールに合わせて、ビジネスコネクションを毎週ご提案します。',
    requestHeroSubtitle: '<em>match-a</em>はSCCIJ会員をランチでつなぎます — 興味・言語・スケジュールでマッチング。',
    authStep1: '興味のある業界と使用言語を登録',
    authStep2: 'ランチの希望スケジュールを選択',
    authStep3: '最適なマッチングをご提案',
    authStep4: '新たなビジネス交流を楽しみましょう！'
  }
};

export const getLocale = () => {
  if (typeof window === 'undefined') return 'en';
  return localStorage.getItem('locale') || 'en';
};

export const setLocale = (locale) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('locale', locale);
    window.location.reload();
  }
};

export const t = (key) => {
  const locale = getLocale();
  return translations[locale]?.[key] || translations.en[key] || key;
};

const locationNamesJa = {
  // Cities
  Tokyo:     '東京',
  Kawasaki:  '川崎',
  Yokohama:  '横浜',
  Chiba:     '千葉',
  Kyoto:     '京都',
  Osaka:     '大阪',
  Kobe:      '神戸',
  Nara:      '奈良',
  Fukuoka:   '福岡',
  Kumamoto:  '熊本',
  Kagoshima: '鹿児島',
  // Regions
  Kanto:  '関東',
  Kansai: '関西',
  Kyushu: '九州',
};

export const tLocation = (name) => {
  if (getLocale() === 'ja') return locationNamesJa[name] || name;
  return name;
};

const businessUnitNamesJa = {
  'AI & Digital': 'AI&デジタル',
  'Consulting & Professional Services': 'コンサルティング&専門サービス',
  'Financial Services & Banking': '金融&銀行',
  'Food & Beverage': '食品&飲料',
  'Industrial & Manufacturing': '製造&メーカー',
  'Pharmaceuticals & Life Sciences': '製薬&ライフサイエンス',
  'Research & Development': '研究開発（R&D）',
  'Technology & Engineering': 'テクノロジー&エンジニアリング',
  'Watchmaking & Luxury': '時計・ラグジュアリー',
};

export const tBusinessUnit = (name) => {
  if (getLocale() === 'ja') return businessUnitNamesJa[name] || name;
  return name;
};

export default { t, getLocale, setLocale };
